export const PRIVACY_POLICY_URL = "https://www.autotrack.nl/privacy-policy";
